import { RouteHttpVerb } from "@devowl-wp/utils";
const locationRestLicenseRetry = {
    path: "/plugin-update/:slug/license/:blogId/retry",
    method: RouteHttpVerb.POST
};
export { locationRestLicenseRetry };
